import { render, staticRenderFns } from "./ExhibitionsBannerExtendedDe.vue?vue&type=template&id=1d5f020e&"
import script from "./ExhibitionsBannerExtendedDe.vue?vue&type=script&lang=js&"
export * from "./ExhibitionsBannerExtendedDe.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionsBannerExtendedDe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports